
import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import AdminUserSearchForm from "@/components/Article/AdminUserSearchForm.vue"
import { mapActions } from "vuex"
import { AdminUser } from "types/adminUser"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { AdminUserSearchForm },
  methods: {
    ...mapActions("article", ["updateArticle"]),
  },
})
export default class SelectAdminUser extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "名前", value: "name" },
      { text: "選択", value: "select", sortable: false },
    ]
  }

  public dialog = false

  @Prop()
  private roleName!: string // コンシェルジュ、編集者、管理者
  @Prop()
  private role!: string // writer, editor
  private title = ""
  private adminUsers: AdminUser["data"][] = []
  private loading = false
  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  public clear(): void {
    this.adminUsers.length = 0
    this.adminUsers = []
    this.resetPagination()
    const form = this.$refs.adminUserSearchForm as InstanceType<
      typeof AdminUserSearchForm
    >
    form.reset()
  }

  public searchResult(result: AdminUser["data"][], totalPages: number): void {
    this.adminUsers = result
    this.totalPages = totalPages
    this.loading = false
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    if (this.dialog) {
      this.loading = true
      setTimeout(() => {
        const adminUserSearchForm = this.$refs
          .adminUserSearchForm as InstanceType<typeof AdminUserSearchForm>
        adminUserSearchForm.search(
          this.pagination.page,
          this.pagination.sortBy[0],
          this.pagination.sortDesc[0]
        )
        this.loading = false
      }, 500)
    }
  }

  private select(adminUser: AdminUser["data"]) {
    if (this.role === "writer") {
      this.$store.dispatch("article/updateArticle", { writer: adminUser })
    } else if (this.role === "editor") {
      this.$store.dispatch("article/updateArticle", { editor: adminUser })
    }
    this.close()
  }
}
